import React from 'react';
import PropTypes from 'prop-types';
import CircularProgress from 'material-ui/CircularProgress';
import './BlueButton.css';

const BlueButton = ({
  children,
  label,
  onClick,
  onMouseDown,
  type,
  disabled,
  loading,
  variant,
  size,
  fullWidth,
  className,
  style,
}) => {
  var variantClass = 'blue-btn--primary';
  if (variant === 'secondary') {
    variantClass = 'blue-btn--secondary';
  } else if (variant === 'danger') {
    variantClass = 'blue-btn--danger';
  }
  var sizeClass = size === 'small' ? 'blue-btn--small' : '';
  var widthClass = fullWidth ? 'blue-btn--full-width' : '';

  var buttonClasses = [
    'blue-btn',
    variantClass,
    sizeClass,
    widthClass,
    className || '',
  ].filter(Boolean).join(' ');

  var content = children || label;
  var isDisabled = disabled || loading;
  var spinnerSize = size === 'small' ? 14 : 18;

  return (
    <button
      type={type || 'button'}
      className={buttonClasses}
      onClick={onClick}
      onMouseDown={onMouseDown}
      disabled={isDisabled}
      style={style}
    >
      {loading && (
        <span className="blue-btn__spinner">
          <CircularProgress size={spinnerSize} thickness={2} color="#ffffff" />
        </span>
      )}
      <span className="blue-btn__label">{content}</span>
    </button>
  );
};

BlueButton.propTypes = {
  children: PropTypes.node,
  label: PropTypes.string,
  onClick: PropTypes.func,
  onMouseDown: PropTypes.func,
  type: PropTypes.oneOf(['button', 'submit', 'reset']),
  disabled: PropTypes.bool,
  loading: PropTypes.bool,
  variant: PropTypes.oneOf(['primary', 'secondary', 'danger']),
  size: PropTypes.oneOf(['default', 'small']),
  fullWidth: PropTypes.bool,
  className: PropTypes.string,
  style: PropTypes.object,
};

BlueButton.defaultProps = {
  type: 'button',
  disabled: false,
  loading: false,
  variant: 'primary',
  size: 'default',
  fullWidth: false,
};

export default BlueButton;
